<template>
<div v-if="realChanged" class="changed-container">
  <h4>Dopo una sincronizzazione è necessario ricaricare la libreria.</h4>
  <v-btn flat primary @click="close"> Ricarica </v-btn>
</div>
</template>

<script>
/**
 * Blocca la dashboard dopo una scrincronizzaione
 * @module components/common/Changed
 */
export default {
  name: 'changed',
  data () {
    return {
      realChanged: false
    }
  },
  props: ['changed'],
  watch: {
    changed (newChanged, oldChanged) {
      if(newChanged && !oldChanged){
        setTimeout(() => {
          this.realChanged = newChanged
        }, 500)
      }else{
        this.realChanged = newChanged
      }
    }
  },
  methods: {
    close () {
      window.location.reload()
    }
  }
}
</script>

<style lang="stylus">
.changed-container
  button
    transform scale(2)
    margin-top 20px
  h4
    text-align center
</style>


// WEBPACK FOOTER //
// src/components/common/Changed.vue